import React, { RefObject, useRef } from 'react';
import useKeydown from '@hooks/useKeydown';
import useOutsideClick from '@hooks/useOutsideClick';
import * as Styled from './DropDownStyles';
import { DropDownProps } from './DropDownTypes';

function DropDown({
  children,
  width,
  onClose,
  borderOff,
  dropdownSpacing = 'km2',
  inputSize,
  outsideRefs = [],
  ...props
}: DropDownProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useOutsideClick(
    [...outsideRefs, wrapperRef as RefObject<HTMLElement>],
    () => {
      if (onClose) {
        onClose(false);
      }
    },
  );

  useKeydown('Escape', () => {
    if (onClose) {
      onClose(false);
    }
  });

  return (
    <Styled.Wrapper ref={wrapperRef}>
      <Styled.Container
        borderOff={borderOff}
        dropdownSpacing={dropdownSpacing}
        width={width}
        position="bottom"
        inputSize={inputSize || 'medium'}
        {...props}
      >
        {children}
      </Styled.Container>
    </Styled.Wrapper>
  );
}

export default DropDown;
